// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: window['env']['production'],
  backend: window['env']['apiUrl'],
  nms: window['env']['nmsApiUrl'],
  socialNetBackend: window['env']['socialNetApiUrl'],
  webSocketUrl: window['env']['webSocket'],
  oidcAuthority: window['env']['oidcAuthority'],
  oidcPwResetPath: window['env']['oidcPwResetPath'],
  oidcClientId: window['env']['oidcClientId'],
  skenDataApiKey: window['env']['skenDataApiKey'],
  skenDataSecretKey: window['env']['skenDataSecretKey'],
  mapsApiKey: window['env']['mapsApiKey'],
  strapi: window['env']['strapiUrl'],
  nmsDev: window['env']['nmsDev'],
  nmsInt: window['env']['nmsInt'],
  nmsSit: window['env']['nmsSit'],
  nmsUat: window['env']['nmsUat'],
  nmsProd: window['env']['nmsProd'],
  oneSignalAppId: window['env']['oneSignalAppId'],
};


/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */

